import { ApiService } from '../services/api_service';
import { DataService } from '../services/data_service';
import { EditBeraterzuordnung } from './editBeraterzuordnung';
import { EditExternerBerater } from './editExternerBerater';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as React from 'react';
import { TriggerService } from '../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

interface EditBeraterProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
    onClose: () => void;
}

interface EditBeraterState extends React.ClassAttributes<any> {
    beraterZugriff: boolean;
    externZugriff: boolean;
    plz: number | string;
    internBerater: number[];
    externBerater: any;
    externBeraterPreset: boolean;
}

export class EditBerater extends React.Component<EditBeraterProps, EditBeraterState> {

    constructor(props: any) {
        super(props);
        this.state = {
            beraterZugriff: false,
            externZugriff: false,
            plz: null,
            internBerater: null,
            externBerater: null,
            externBeraterPreset: false
        };
        this.saveBerater = this.saveBerater.bind(this);
        this.callBeforeOnFormSave = this.callBeforeOnFormSave.bind(this);
        this.savePLZ = this.savePLZ.bind(this);
        this.customValidate = this.customValidate.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    render() {
        if (!this.props.data) {
            return null;
        }
        const data: any = this.props.data || {};
        const unternehmensdaten: any = (data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        const bereich_key: string = unternehmensdaten.bereich_key_orig || null;
        const tid: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).tid || null;

        const fields = ['berater_zugriff'];
        if (this.state.beraterZugriff) {
            // WKETOOL-112: Sonstige darf interne Berater wählen
            // if (bereich_key !== 'sonstige') {
            //     // WKETOOL-66: 358
            //     fields.push('plz');
            // }
            fields.push('plz');
            fields.push('externer_berater');
        }

        const customFormConfig: any = {
            plz: { typ: 'text' }
        };

        // WKETOOL-112: Sonstige darf interne Berater wählen
        // if (bereich_key === 'sonstige') {
        //     customFormConfig.externer_berater = {
        //         // WKETOOL-69: 358
        //         readonly: true,
        //         label: 'Möchten Sie eine(n) eigene(n) Berater:in/Expert:in anlegen, und das E-Tool für diesen freischalten?'
        //     };
        // }

        return <div>
            <WFormsTableWrapper
                containerId={this.props.containerId}
                formSelectOptionAsRadio={true}
                key='konfiguration_form'
                hideTitel={true}
                entity={IDs.ENT_KONFIGURATION}
                module={IDs.MOD_ETOOL}
                directEditFormularOf={{ tid }}
                inlineFormular={true}
                validRestriction='ignore'
                validateField={this.customValidate}
                callBeforeOnFormSave={this.callBeforeOnFormSave}
                onAfterAction={(action: string) => {
                    if (action === 'closeForm') {
                        this.props.onClose();
                    }
                    if (action === 'saveDone') {
                        this.saveBerater();
                        this.savePLZ();
                    }
                }}
                disableFieldSelectDefaultOptions={{
                    berater_zugriff: true,
                    externer_berater: true
                }}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION)}
                formLayout='flowV2'
                customClass='Custom-ETA'
                customFormConfig={customFormConfig}
                formGroupOrder={[{ fields }]}
                extraFormElementAfter={{
                    ...(this.state.beraterZugriff ? {
                        plz: <EditBeraterzuordnung
                            data={this.props.data}
                            plz={this.state.plz}
                            onChange={(internBerater: number[]) => this.setState({ internBerater })}
                        />
                    } : {}),
                    ...(this.state.beraterZugriff && this.state.externZugriff ? {
                        externer_berater: <EditExternerBerater
                            data={this.props.data}
                            onChange={(externBerater: any, externBeraterPreset: boolean) =>
                                this.setState({ externBerater, externBeraterPreset })
                            }
                        />
                    } : {})
                }}
                customCssStyle={{ formcontainer: { maxHeight: 530, overflowY: 'auto' }, outerStyle: { backgroundColor: 'white' } }}
            />
        </div>;
    }

    customValidate(key: string, value: any, dat: any, onValueChange: (name: string, value: any) => void): string {
        const data: any = this.props.data || {};
        const unternehmensdaten: any = (data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        const bereich_key: string = unternehmensdaten.bereich_key_orig || null;
        const defPlz: number | string = unternehmensdaten.plz || null;
        if (key === 'berater_zugriff') {
            if (+value === 1) {
                this.setState({ beraterZugriff: true });
            } else {
                // WKETOOL-112: Sonstige darf interne Berater wählen
                // if (bereich_key === 'sonstige') {
                //     // WKETOOL-102: 453
                //     // Wenn man als Nutzer:in die Frage 'berater_zugriff' mit Nein beantwortet, 
                //     // dann wird die Berater:innen-Zuordnung automatisch gelöscht und es kommt kein Fehlerhinweis.
                //     this.setState({ beraterZugriff: false });
                // } else {
                //     const savedBerater: any[] = data.RES_MAIN_LOAD_BERATER || [];
                //     const { internBerater } = this.state;
                //     if ((!internBerater && savedBerater.length > 0) ||
                //         (Array.isArray(internBerater) && internBerater.length > 0)) {
                //         onValueChange(key, 1);
                //         const info = 'Bitte entfernen Sie zunächst den bzw. die ausgewählten Berater!';
                //         alert(info);
                //     } else {
                //         this.setState({ beraterZugriff: false });
                //     }
                // }

                const savedBerater: any[] = data.RES_MAIN_LOAD_BERATER || [];
                const { internBerater } = this.state;
                if ((!internBerater && savedBerater.length > 0) ||
                    (Array.isArray(internBerater) && internBerater.length > 0)) {
                    onValueChange(key, 1);
                    const info = 'Bitte entfernen Sie zunächst den bzw. die ausgewählten Berater!';
                    alert(info);
                } else {
                    this.setState({ beraterZugriff: false });
                }
            }

            // WKETOOL-112: Sonstige darf interne Berater wählen
            // if (bereich_key === 'sonstige' && +value !== +dat.values.externer_berater) {
            //     // WKETOOL-69: 358
            //     onValueChange('externer_berater', +value);
            // }
        }
        if (key === 'externer_berater') {
            if (+value === 1) {
                if (!this.state.externZugriff) {
                    this.setState({ externZugriff: true },
                        () => window.setTimeout(() => {
                            const elem = document.getElementById('form_externer_berater');
                            if (elem) {
                                elem.scrollIntoView({ behavior: 'smooth' });
                            }
                        }, 500)
                    );
                }
            } else {
                this.setState({ externZugriff: false });
            }
        }
        if (key === 'plz') {
            if ((!value && !this.state.plz) && defPlz) {
                value = defPlz;
                onValueChange('plz', value);
            }
            this.setState({ plz: value });
        }
        return undefined;
    }

    callBeforeOnFormSave(data: any, callback: () => void) {
        const { beraterZugriff, externZugriff, externBerater, externBeraterPreset } = this.state;
        // console.log(beraterZugriff, externZugriff, externBerater);
        if (beraterZugriff && externZugriff && !externBeraterPreset && (!externBerater || !externBerater.mail || !externBerater.name)) {
            alert('Bitte füllen Sie alle Pflichtfelder aus!');
        } else if (externZugriff && externBerater && externBerater.mail) {
            this.apiService.call('checkMailExistence', { mail: externBerater.mail, tid: externBerater.tid, entity: IDs.ENT_BERATER, module: IDs.MOD_ETOOL_ADMIN },
                (res: string, suc: boolean) => {
                    // console.log(res, suc);
                    if (suc) {
                        if (res === '1') {
                            alert('E-Mail-Adresse existiert bereits.');
                        } else if (typeof callback === 'function') {
                            callback();
                        }
                    } else {
                        alert('Server Error');
                    }
                }
            );
        } else {
            callback();
        }
    }

    saveBerater() {
        const { beraterZugriff, internBerater, externZugriff, externBerater } = this.state;
        // console.log(beraterZugriff, internBerater, externZugriff, externBerater);
        // Zuordnungen mit internern Beratern anlegen.
        this.apiService.call('updateBeraterzuordnung', {
            beraterZugriff: beraterZugriff ? 1 : 0,
            // 1 für [], weil ajax [] als null sendet.
            internBerater: Array.isArray(internBerater) && internBerater.length === 0 ? 1 : internBerater,
            externZugriff: externZugriff ? 1 : 0,
            externBerater
        }, (data: string, succ: boolean) => {
            // console.log(data);
            if (succ) {
                // this.triggerService.fire('reload', IDs.ENT_BERATERZUORDNUNG);
                this.triggerService.fire('reload', IDs.ENT_BERATER);
                this.triggerService.fire('reload', 'main.loadBerater');
                alert('Der/die von Ihnen ausgewählte Berater/in wurde per E-Mail informiert.');
            }
        }, IDs.MOD_ETOOL_ADMIN);
    }

    savePLZ() {
        const { plz } = this.state;
        const { data } = this.props;
        if (!isNaN(+plz) && +plz > 0 && Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0) {
            const row = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            if (row.tid > 0 && !row.plz) {
                const values: any = { tid: row.tid, plz };
                this.dataService.saveData(IDs.ENT_UNTERNEHMENSDATEN, values, undefined, false,
                    (success: boolean) => {
                        if (success) {
                            this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN);
                        }
                    }, IDs.MOD_ETOOL);
            }
        }
    }
}
